// Free click-to-chat helper. The destination number is configuration (VITE_WHATSAPP_NUMBER),
// defaulting to the sales line, so it is never hardcoded across components.
const digitsOnly = (value: string) => value.replace(/[^0-9]/g, '');

export const whatsAppNumber = digitsOnly(
  (import.meta.env.VITE_WHATSAPP_NUMBER as string | undefined) || '201060793140',
);

export function whatsAppLink(message?: string): string {
  const base = `https://wa.me/${whatsAppNumber}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
